import { Api } from "@workspace/auth-client/client";
import { authFetch } from "./auth-fetch";

/**
 * Global API client instance.
 * Uses the generated Api class with authFetch for credentials
 * and automatic 401 token refresh.
 */
const apiClient = new Api<string>({
  baseUrl: process.env.NEXT_PUBLIC_API_URL,
  baseApiParams: {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  },
  securityWorker: (securityData) => {
    if (securityData) {
      return {
        headers: {
          Authorization: `Bearer ${securityData}`,
        },
      };
    }
    return {};
  },
  customFetch: authFetch,
});

console.log(
  "[API Client] Initialized with baseUrl:",
  process.env.NEXT_PUBLIC_API_URL
);

export { apiClient };
